import React, { useState, useEffect, useRef } from 'react';
import { ProductService } from '../services/productService';
import Pagination from '../components/Pagination';
import ProductList from '../components/ProductList';
import '../styles/ProductPage.css';
import { FaPlus, FaEdit, FaTrash, FaSearch, FaTimes, FaTag, FaImage } from 'react-icons/fa';

const ProductPage = () => {
  const [products, setProducts] = useState([]);
  const [newAttribute, setNewAttribute] = useState({ key: '', value: '' });
  const [imagePreviews, setImagePreviews] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState('');
  const [newProduct, setNewProduct] = useState({
    name: '',
    brand: '',
    model: '',
    attributes: [],
    productCode: '',
    description: '',
    price: '',
    category: '',
    stock: '',
    images: [],
    onSale: false,
    discountPercentage: 0,
  });
  const [showForm, setShowForm] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [currentProductPage, setCurrentProductPage] = useState(1);
  const [itemsPerProductPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [showSubcategoryInput, setShowSubcategoryInput] = useState(false);
  const [showTopLevelCategoryInput, setShowTopLevelCategoryInput] = useState(false);
  const [selectedParentCategory, setSelectedParentCategory] = useState(null);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [showBulkSaleModal, setShowBulkSaleModal] = useState(false);
  const [bulkDiscount, setBulkDiscount] = useState({
    type: 'selected',
    category: '',
    discountPercentage: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const API_URL =  `${API_BASE_URL}`;


  const formRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      await Promise.all([fetchProductsList(), fetchCategories()]);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };

const fetchProductsList = async () => {
  setIsLoading(true);
  try {
    const response = await ProductService.fetchEweProducts();
    console.log('API Response:', response);

    const eweProducts = response.products || response.data || response || [];
    console.log('Raw products:', eweProducts);

    const transformedProducts = eweProducts
      .filter(product => product.anProductKey) // Validate using correct field name
      .map(product => ({
        // Use correct field names from the API response
        id: product.anProductKey.toString(),
        name: product.acName || 'Unnamed Product',
        productCode: product.acProduct || 'N/A',
        description: product.acProductDescription || '',
                price: parseFloat(product.anPrice) || 0,
                retailPrice:parseFloat(product.anRetailPrice) || 0,
                promoPrice: parseFloat(product.promoPrice) || 0,
        stock: product.anStock || 0,
        imageUrls: product.imageUrls || [],
        category: {
          id: product.anCategoryKey || 0,
          name: product.acCategory || 'Uncategorized',
          parentId: product.anMainCategoryKey || 0
        },
        brand: product.acDept || '',
        model: product.acModel || '',
        attributes: (product.specification || []).flatMap(group =>
          (group.filters || []).map(filter => ({
            key: filter.acFilterSet || 'Unknown',
            value: filter.filters || 'N/A'
          }))
        ),
        // Add additional fields from the API response
        department: product.acDept,
        sku: product.acProduct,
        specifications: product.acInlineSpecification,
        stockStatus: product.anStock > 0 ? 'In Stock' : 'Out of Stock',
        discount: product.anDiscount || 0,
        isPromo: product.isPromotion === 1
      }));

    console.log('Transformed products:', transformedProducts);

    setProducts(transformedProducts);
    setFilteredProducts(transformedProducts);

  } catch (error) {
    console.error('Fetch error:', error);
    setProducts([]);
    setFilteredProducts([]);
  } finally {
    setIsLoading(false);
  }
};



  const fetchCategories = async () => {
    try {
      const response = await ProductService.fetchCategories();
      setCategories(response);
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const getCategoryPath = (categoryId, categories) => {
    const findCategory = (id, categories) => {
      for (const category of categories) {
        if (category.id === id) {
          return category;
        }
        if (category.children) {
          const found = findCategory(id, category.children);
          if (found) return found;
        }
      }
      return null;
    };

    const buildPath = (category) => {
      if (!category) return '';
      const parentPath = category.parentId ? buildPath(findCategory(category.parentId, categories)) : '';
      return parentPath ? `${parentPath} -> ${category.name}` : category.name;
    };

    const category = findCategory(categoryId, categories);
    return buildPath(category);
  };

  const handleSearchChange = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    const filtered = products.filter(
      (product) =>
        product.name.toLowerCase().includes(term) ||
        (product.category?.name || '').toLowerCase().includes(term) ||
        product.description.toLowerCase().includes(term)
    );

    setFilteredProducts(filtered);
    setCurrentProductPage(1);
  };

const handleInputChange = (e) => {
  const { name, value } = e.target;
  if (name === 'key' || name === 'value') {
    // Using key and value for the attribute object properties
    setNewAttribute((prev) => ({
      ...prev,
      [name]: value
    }));
  } else {
    setNewProduct({ ...newProduct, [name]: value });
  }
  setFormErrors({ ...formErrors, [name]: '' });
};
  const handleCategoryChange = (e) => {
    const selectedCategoryId = e.target.value;
    if (selectedCategoryId === 'add-new-top-category') {
      setShowTopLevelCategoryInput(true);
      setNewProduct((prev) => ({ ...prev, category: '' }));
    } else {
      setNewProduct((prev) => ({ ...prev, category: selectedCategoryId }));
      setSelectedParentCategory(selectedCategoryId);
      setShowSubcategoryInput(false);
    }
  };

  const handleAddTopCategory = async () => {
    if (newCategory.trim()) {
      if (selectedCategory) {
        await handleUpdateCategory(selectedCategory.id, newCategory);
      } else {
        await handleAddCategory(null);
      }
      setShowTopLevelCategoryInput(false);
      setSelectedCategory(null);
      setNewCategory('');
    }
  };

  const handleAddSubcategory = async (parentId, name) => {
    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();
      formData.append('name', name);
      formData.append('parentId', parentId.toString());

      const response = await fetch(`${API_URL}/products/addcategories`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (response.ok) {
        await fetchCategories();
        setNewCategory('');
      }
    } catch (error) {
      console.error('Error adding subcategory:', error);
      alert('Failed to add subcategory: ' + error.message);
    }
  };

  const handleAddCategory = async (parentId) => {
    if (newCategory.trim()) {
      try {
        const token = localStorage.getItem('token');
        const formData = new FormData();
        formData.append('name', newCategory);
        if (parentId) formData.append('parentId', parentId.toString());

        const response = await fetch( `${API_BASE_URL}/products/addcategories`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });

        if (response.ok) {
          const savedCategory = await response.json();
          await fetchCategories();
          setNewProduct((prev) => ({ ...prev, category: savedCategory.id }));
          setNewCategory('');
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }
  };

  const handleUpdateCategory = async (categoryId, newName) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch( `${API_BASE_URL}/products/categories/${categoryId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ name: newName }),
      });

      if (!response.ok) {
        throw new Error('Failed to update category');
      }

      await fetchCategories();
    } catch (error) {
      console.error('Error updating category:', error);
      alert('Failed to update category: ' + error.message);
    }
  };


  const handleAddAttribute = () => {
    if (newAttribute.key.trim() && newAttribute.value.trim()) {
      setNewProduct((prev) => ({
        ...prev,
        attributes: [...prev.attributes, { key: newAttribute.key, value: newAttribute.value }],
      }));
      setNewAttribute({ key: '', value: '' }); // Reset input fields
    }
  };

  const handleRemoveAttribute = (index) => {
    setNewProduct((prev) => ({
      ...prev,
      attributes: prev.attributes.filter((_, i) => i !== index),
    }));
  };


  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const newPreviews = files.map((file) => URL.createObjectURL(file));

    setImagePreviews((prev) => [...prev, ...newPreviews]);
    setNewProduct((prev) => ({
      ...prev,
      images: [...prev.images, ...files],
    }));
  };

const handleDeleteExistingImage = async (imageId) => {
  if (!selectedProduct?.id) return;

  try {
    await fetch(`${API_URL}/products/${selectedProduct.id}/images/${imageId}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    // Update the selected product's images immediately
    setSelectedProduct(prev => ({
      ...prev,
      images: prev.images.filter(img => img.id !== imageId)
    }));

    // Also update the main products list
    const updatedProducts = products.map(product => {
      if (product.id === selectedProduct.id) {
        return {
          ...product,
          images: product.images.filter(img => img.id !== imageId)
        };
      }
      return product;
    });

    setProducts(updatedProducts);
    setFilteredProducts(updatedProducts);

  } catch (error) {
    console.error('Error deleting image:', error);
    alert('Failed to delete image');
  }
};


  const validateForm = () => {
    const errors = {};
    if (!newProduct.name.trim()) errors.name = 'Product name is required';
    if (!newProduct.productCode.trim()) errors.productCode = 'Product code is required';
    if (!newProduct.price || isNaN(newProduct.price)) errors.price = 'Valid price is required';
    if (!newProduct.category) errors.category = 'Category is required';
    return errors;
  };

  const handleRemoveImage = (index) => {
    const newImages = [...newProduct.images];
    const newPreviews = [...imagePreviews];

    // Clean up memory
    URL.revokeObjectURL(newPreviews[index]);

    newImages.splice(index, 1);
    newPreviews.splice(index, 1);

    setNewProduct((prev) => ({ ...prev, images: newImages }));
    setImagePreviews(newPreviews);
  };

const handleAddProduct = () => {
  setShowForm(true);
  setIsEditing(false);
  setNewProduct({
    name: '',
    productCode: '',
    description: '',
    price: '',
    category: '',
    stock: '',
    images: [],
    onSale: false,
    discountPercentage: 0,
    brand: '', // Missing in current code
    model: '', // Missing in current code
    attributes: [] // Missing in current code
  });
};

  const renderCategoriesOptions = (categories, level = 0) => {
    return categories.map((category) => (
      <React.Fragment key={category.id}>
        <option value={category.id}>
          {`${'— '.repeat(level)}${category.name}`}
        </option>
        {category.children &&
          renderCategoriesOptions(category.children, level + 1)}
      </React.Fragment>
    ));
  };



const handleSubmitProduct = async () => {
  try {
    setIsLoading(true);
    const formData = new FormData();
    const token = localStorage.getItem('token');

    // Add all product fields
    formData.append('name', newProduct.name);
    formData.append('productCode', newProduct.productCode);
    formData.append('description', newProduct.description);
    formData.append('price', newProduct.price);
    formData.append('stock', newProduct.stock);
    formData.append('categoryId', newProduct.category);
    formData.append('onSale', newProduct.onSale);
    formData.append('discountPercentage', newProduct.discountPercentage);
    formData.append('brand', newProduct.brand);
    formData.append('model', newProduct.model);

    // Add attributes as JSON string
    formData.append('attributes', JSON.stringify(newProduct.attributes));

    // Add images
    newProduct.images.forEach((image) => {
      formData.append('images', image);
    });

    const url = isEditing && selectedProduct
      ? `${API_URL}/products/${selectedProduct.id}`
      : `${API_URL}/products`;

    const response = await fetch(url, {
      method: isEditing ? 'PUT' : 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.text();
      throw new Error(errorData);
    }

    await fetchProductsList();
    resetForm();
  } catch (error) {
    console.error('Error saving product:', error);
    alert(`Save failed: ${error.message}`);
  } finally {
    setIsLoading(false);
  }
};
const resetForm = () => {
  setNewProduct({
    name: '',
    productCode: '',
    description: '',
    price: '',
    category: '',
    stock: '',
    images: [],
    onSale: false,
    discountPercentage: 0,
    brand: '', // Reset brand
    model: '', // Reset model
    attributes: [], // Reset attributes
  });
  setNewAttribute({ key: '', value: '' }); // Reset attribute input
  setShowForm(false);
  setIsEditing(false);
  setSelectedProduct(null);
  setFormErrors({});
};

const handleEditProduct = (product) => {
  setSelectedProduct(product);
  setNewProduct({
    name: product.name,
    productCode: product.productCode,
    description: product.description,
    price: product.price.toString(),
    retailPrice: product.retailPrice.toString(),
    category: product.category?.id || '',
    stock: product.stock.toString(),
    images: product.images || [],
    onSale: product.onSale || false,
    discountPercentage: product.discountPercentage || 0,
    brand: product.brand || '', // Populate brand
    model: product.model || '', // Populate model
    attributes: product.attributes || [], // Populate attributes
  });
  setShowForm(true);
  setIsEditing(true);
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleDeleteProduct = async (id) => {
    try {
      await ProductService.removeProduct(id);
      fetchProductsList();
    } catch (error) {
      console.error('Error deleting product:', error);
    }
  };

  const handleEditCategory = async (category) => {
    try {
      const token = localStorage.getItem('token');
      const url =  `${API_BASE_URL}/categories/${category.id}`;

      // Create URLSearchParams for form data
      const formData = new URLSearchParams();
      formData.append('name', category.name);
      if (category.parent?.id) {
        formData.append('parentId', category.parent.id);
      }

      const response = await fetch(url, {
        method: 'PUT', // Match backend's PutMapping
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to update category: ${errorText}`);
      }

      await fetchCategories(); // Refresh category list
    } catch (error) {
      console.error('Error updating category:', error);
      alert(error.message);
    }
  };

  const handleDeleteCategory = async (categoryId) => {
    console.log("Attempting to delete category with ID:", categoryId); // Debugging
    try {
      const token = localStorage.getItem('token');
      if (!token) throw new Error('Authorization token missing');

      const confirmDelete = window.confirm(
        'Are you sure you want to delete this category? This will permanently delete ALL products and subcategories under it!'
      );
      if (!confirmDelete) {
        console.log("Deletion canceled by user"); // Debugging
        return;
      }

      const response = await fetch(`${API_URL}/categories/${categoryId}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Server responded with error:", errorText); // Debugging
        throw new Error(errorText);
      }

      await Promise.all([fetchCategories(), fetchProductsList()]);
      alert('Category deleted successfully!');
    } catch (error) {
      console.error('Deletion error:', error); // Debugging
      console.error('Error message:', error.message); // Log the error message
      if (error.message.includes("Cannot delete category with existing products")) {
        alert("Cannot delete category: There are still products in this category.");
      } else {
        alert(`Deletion failed: ${error.message}`);
      }
    }
  };

  const toggleProductSelection = (productId) => {
    setSelectedProducts((prev) =>
      prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId]
    );
  };

  const toggleSelectAll = () => {
    if (selectedProducts.length === products.length) {
      setSelectedProducts([]);
    } else {
      setSelectedProducts(products.map((p) => p.id));
    }
  };

  const handleBulkDiscountChange = (e) => {
    const { name, value } = e.target;
    setBulkDiscount((prev) => ({
      ...prev,
      [name]: name === 'discountPercentage' ? Number(value) : value,
    }));
  };

  const applyBulkDiscount = async () => {
    try {
      const payload = {
        type: bulkDiscount.type,
        discountPercentage: bulkDiscount.discountPercentage,
        category: bulkDiscount.type === 'category' ? bulkDiscount.category : null,
        productIds: bulkDiscount.type === 'selected' ? selectedProducts : null,
      };

      await ProductService.applyBulkDiscount(payload);
      await fetchProductsList();
      setShowBulkSaleModal(false);
      setSelectedProducts([]);
      alert('Discount applied successfully!');
    } catch (error) {
      console.error('Error applying bulk discount:', error);
      alert('Failed to apply discount: ' + error.message);
    }
  };


  const CustomCategoryDropdown = ({
    categories,
    selectedCategory,
    onSelectCategory,
    onEditCategory,
    onDeleteCategory,
    onAddSubcategory,
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [editingCategory, setEditingCategory] = useState(null);
    const [newSubcategoryName, setNewSubcategoryName] = useState('');

    const handleCategoryClick = (categoryId) => {
      onSelectCategory(categoryId);
      setIsOpen(false); // Close the dropdown after selection
    };

    const findCategoryById = (categories, id) => {
      for (const category of categories) {
        if (category.id === id) return category;
        if (category.children) {
          const found = findCategoryById(category.children, id);
          if (found) return found;
        }
      }
      return null;
    };

    const handleEditClick = (category, e) => {
      e.stopPropagation(); // Prevent dropdown from closing
      setEditingCategory(category); // Set the category to edit
    };

    const handleDeleteClick = (categoryId, e) => {
      console.log("Delete button clicked for category ID:", categoryId); // Debugging
      e.stopPropagation(); // Prevent dropdown from closing
      onDeleteCategory(categoryId); // Call the delete function
    };

    const handleSaveEdit = (updatedCategory) => {
      onEditCategory({
        id: updatedCategory.id,
        name: updatedCategory.name,
        parent: updatedCategory.parentId ? { id: updatedCategory.parentId } : null,
      });
      setEditingCategory(null);
    };

    const handleAddSubcategoryClick = (categoryId, e) => {
      e.stopPropagation(); // Prevent dropdown from closing
      setEditingCategory({ id: categoryId, name: '' }); // Set the parent category for adding a subcategory
    };

    const handleSaveSubcategory = () => {
      if (newSubcategoryName.trim()) {
        onAddSubcategory(editingCategory.id, newSubcategoryName);
        setNewSubcategoryName('');
        setEditingCategory(null); // Close the subcategory form
      }
    };

    const renderCategories = (categories, level = 0) => {
      return categories.map((category) => (
        <React.Fragment key={category.id}>
          <div
            className="dropdown-item"
            style={{ paddingLeft: `${level * 20}px` }} // Indent subcategories
            onClick={() => handleCategoryClick(category.id)}
          >
            <span className="category-name">{category.name}</span>
            <div className="category-actions">
              <button
                className="category-edit-btn"
                onClick={(e) => handleEditClick(category, e)}
              >
                <FaEdit />
              </button>
              <button
                className="category-delete-btn"
                onClick={(e) => handleDeleteClick(category.id, e)}
              >
                <FaTrash />
              </button>
              <button
                className="category-add-subcategory-btn"
                onClick={(e) => handleAddSubcategoryClick(category.id, e)}
              >
                <FaPlus />
              </button>
            </div>
          </div>
          {category.children && renderCategories(category.children, level + 1)}
        </React.Fragment>
      ));
    };

    return (
      <div className="custom-dropdown">
        <div className="dropdown-header" onClick={() => setIsOpen(!isOpen)}>
          {selectedCategory
            ? findCategoryById(categories, selectedCategory)?.name || 'Select Category'
            : 'Select Category'}
          <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
        </div>
        {isOpen && (
          <div className="dropdown-list">
            {renderCategories(categories)}
          </div>
        )}

        {editingCategory && (
          <div className="edit-category-modal">
            <div className="edit-category-form">
              {editingCategory.name ? (
                <>
                  <input
                    type="text"
                    value={editingCategory.name}
                    onChange={(e) =>
                      setEditingCategory({ ...editingCategory, name: e.target.value })
                    }
                  />
                  <button onClick={() => handleSaveEdit(editingCategory)}>Sačuvaj</button>
                  <button onClick={() => setEditingCategory(null)}>Poništi</button>
                </>
              ) : (
                <>
                  <input
                    type="text"
                    value={newSubcategoryName}
                    onChange={(e) => setNewSubcategoryName(e.target.value)}
                    placeholder="Enter subcategory name"
                  />
                  <button onClick={handleSaveSubcategory}>Dodaj potkategoriju</button>
                  <button onClick={() => setEditingCategory(null)}>Poništi</button>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="product-management-container">
      <ProductList
        products={products}
        filteredProducts={filteredProducts}
        selectedProducts={selectedProducts}
        searchTerm={searchTerm}
        currentProductPage={currentProductPage}
        itemsPerProductPage={itemsPerProductPage}
        getCategoryPath={getCategoryPath}
        categories={categories}
        onSearchChange={handleSearchChange}
        toggleProductSelection={toggleProductSelection}
        toggleSelectAll={toggleSelectAll}
        onPageChange={setCurrentProductPage}
        onAddProduct={handleAddProduct}
        onEditProduct={handleEditProduct}
        onDeleteProduct={handleDeleteProduct}
      />


      {showForm && (
        <div className="form-modal-overlay">
          <div className="form-modal-content" ref={formRef}>
            <div className="form-modal-header">
              <h2>{isEditing ? 'Edit Product' : 'New Product'}</h2>
              <button className="close-btn" onClick={resetForm}>
                <FaTimes />
              </button>
            </div>

            <div className="form-grid">
              <div className="form-column">
                <div className="form-group">
                  <label>Ime Proizvoda</label>
                  <input
                    type="text"
                    name="name"
                    value={newProduct.name}
                    onChange={handleInputChange}
                    placeholder="Enter product name"
                  />
                </div>
        {/* Add Brand and Model Fields */}
          <div className="form-group">
            <label>Brand</label>
            <input
              type="text"
              name="brand"
              value={newProduct.brand}
              onChange={handleInputChange}
              placeholder="Enter brand name"
            />
          </div>

          <div className="form-group">
            <label>Model</label>
            <input
              type="text"
              name="model"
              value={newProduct.model}
              onChange={handleInputChange}
              placeholder="Enter model name"
            />
          </div>

          {/* Dynamic Attributes Section */}
          <div className="form-group">
            <label>Attributes</label>
            <div className="attributes-container">
              {newProduct.attributes.map((attr, index) => (
                <div key={index} className="attribute-item">
                  <span>{attr.key}: {attr.value}</span>
                  <button
                    className="remove-attribute-btn"
                    onClick={() => handleRemoveAttribute(index)}
                  >
                    <FaTimes />
                  </button>
                </div>
              ))}
<div className="add-attribute-form">
  <input
    type="text"
    name="key" // Changed from attributeKey
    value={newAttribute.key}
    onChange={handleInputChange}
    placeholder="Attribute key"
  />
  <input
    type="text"
    name="value" // Changed from attributeValue
    value={newAttribute.value}
    onChange={handleInputChange}
    placeholder="Attribute value"
  />
  <button className="add-attribute-btn" onClick={handleAddAttribute}>
    <FaPlus /> Add Attribute
  </button>
</div>
            </div>
          </div>
                <div className="form-group">
                  <label>Serijski Broj</label>
                  <input
                    type="text"
                    name="productCode"
                    value={newProduct.productCode}
                    onChange={handleInputChange}
                    placeholder="Unique product code"
                  />
                </div>

                <div className="form-group">
                  <label>Opis</label>
                  <textarea
                    name="description"
                    value={newProduct.description}
                    onChange={handleInputChange}
                    placeholder="Product description..."
                    rows="3"
                    maxLength="500"
                  />
                </div>
              </div>

              <div className="form-column">
                <div className="form-group">
                  <label>Kategorija</label>
                  <CustomCategoryDropdown
                    categories={categories}
                    selectedCategory={newProduct.category}
                    onSelectCategory={(categoryId) =>
                      setNewProduct((prev) => ({ ...prev, category: categoryId }))
                    }
                    onEditCategory={handleEditCategory}
                    onDeleteCategory={handleDeleteCategory}
                    onAddSubcategory={(parentId, name) =>
                      handleAddSubcategory(parentId, name)
                    }
                  />
                  <button
                    className="add-category-btn"
                    onClick={() => setShowTopLevelCategoryInput(true)}
                  >
                    <FaPlus /> Dodaj Novu Kategoriju
                  </button>
                </div>
                {showTopLevelCategoryInput && (
                  <div className="add-category-input">
                    <input
                      type="text"
                      value={newCategory}
                      onChange={(e) => setNewCategory(e.target.value)}
                      placeholder="Enter new category name"
                    />
                    <button onClick={handleAddTopCategory}>
                      <FaPlus /> Sačuvaj
                    </button>
                    <button onClick={() => setShowTopLevelCategoryInput(false)}>
                      <FaTimes /> Poništi
                    </button>
                  </div>
                )}
                <div className="form-group">
                  <label>Cena (RSD)</label>
                  <input
                    type="number"
                    name="price"
                    value={newProduct.price}
                    onChange={handleInputChange}
                    step="0.01"
                    placeholder="0.00"
                  />
                </div>

                <div className="form-group">
                  <label>Količina</label>
                  <input
                    type="number"
                    name="stock"
                    value={newProduct.stock}
                    onChange={handleInputChange}
                    placeholder="Available quantity"
                  />
                </div>

                <div className="form-group checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      name="onSale"
                      checked={newProduct.onSale}
                      onChange={(e) => setNewProduct({ ...newProduct, onSale: e.target.checked })}
                    />
                    On Sale
                  </label>
                </div>

                {newProduct.onSale && (
                  <div className="form-group">
                    <label>Procenat Popusta</label>
                    <div className="discount-input">
                      <input
                        type="number"
                        name="discountPercentage"
                        value={newProduct.discountPercentage}
                        onChange={handleInputChange}
                        min="0"
                        max="100"
                        placeholder="0-100%"
                      />
                      <span>%</span>
                    </div>
                  </div>
                )}

                <div className="form-group">
                  <label>Slika Proizvoda</label>
                  <div className="file-upload-container">
                    <label className="file-upload-button">
                      <FaImage /> Add Images
                      <input
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        className="hidden-input"
                        accept="image/*"
                      />
                    </label>
                    <div className="image-previews">
                      {imagePreviews.map((preview, index) => (
                        <div key={index} className="image-preview-item">
                          <img src={preview} alt={`Preview ${index}`} />
                          <button
                            className="remove-image-btn"
                            onClick={() => handleRemoveImage(index)}
                          >
                            <FaTimes />
                          </button>
                        </div>
                      ))}
                    </div>
                    {imagePreviews.length > 0 && (
                      <div className="selected-files-count">
                        {imagePreviews.length} file(s) selected
                      </div>
                    )}
                  </div>
                  {isEditing && selectedProduct?.images && (
                    <div className="current-images-preview">
                      <h4>Existing Images:</h4>
                      <div className="image-grid">
                        {selectedProduct.images.map((image) => (
                          <div key={image.id} className="image-preview">
                            <img
                              src={image.imageUrl?.startsWith('http')
                                ? image.imageUrl
                                :  `${API_BASE_URL}${image.imageUrl}`}
                              alt="Current"
                            />
                              <button
                                className="remove-image-btn"
                                onClick={() => handleDeleteExistingImage(image.id)}
                              >
                                <FaTimes />
                              </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="form-actions">
              <button className="save-btn" onClick={handleSubmitProduct}>
                <FaEdit /> {isEditing ? 'Update Product' : 'Create Product'}
              </button>
              <button className="cancel-btn" onClick={resetForm}>
                Poništi
              </button>
            </div>
          </div>
        </div>
      )}

      {showBulkSaleModal && (
        <div className="form-modal-overlay">
          <div className="form-modal-content">
            <div className="form-modal-header">
              <h2>Dodaj popust</h2>
              <button className="close-btn" onClick={() => setShowBulkSaleModal(false)}>
                <FaTimes />
              </button>
            </div>

            <div className="form-grid">
              <div className="form-column">
                <div className="form-group">
                  <label>Tip popusta</label>
                  <select
                    name="type"
                    value={bulkDiscount.type}
                    onChange={handleBulkDiscountChange}
                  >
                    <option value="selected">Izabrani proizvodi</option>
                    <option value="category">Cela Kategorija</option>
                  </select>
                </div>

                {bulkDiscount.type === 'category' && (
                  <div className="form-group">
                    <label>Kategorija</label>
                    <select
                      name="category"
                      value={bulkDiscount.category}
                      onChange={handleBulkDiscountChange}
                    >
                      <option value="">Izaberi Kategoriju</option>
                      {renderCategoriesOptions(categories)}
                    </select>
                  </div>
                )}

                <div className="form-group">
                  <label>Procenat Popusta</label>
                  <div className="discount-input">
                    <input
                      type="number"
                      name="discountPercentage"
                      value={bulkDiscount.discountPercentage}
                      onChange={handleBulkDiscountChange}
                      min="0"
                      max="100"
                      placeholder="0-100%"
                    />
                    <span>%</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="form-actions">
              <button className="save-btn" onClick={applyBulkDiscount}>
                Primeni popust
              </button>
              <button className="cancel-btn" onClick={() => setShowBulkSaleModal(false)}>
                Poništi
              </button>
            </div>
          </div>
        </div>
      )}

      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>
      )}
    </div>
  );
};

export default ProductPage;